import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

// Rutas
import { APP_ROUTES } from './app.routes';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './pages/app.component';
import { GraphicDesignComponent } from './pages/graphic-design/graphic-design.component';
import { VideoComponent } from './pages/video/video.component';
import { WebDesignComponent } from './pages/web-design/web-design.component';
import { AdemasComponent } from './pages/ademas/ademas.component';
import { MenuPrincipalComponent } from './shared/menu-principal/menu-principal.component';
import { PagesComponent } from './pages/pages.component';
import { PrincipalComponent } from './principal/principal.component';
import { FooterComponent } from './shared/footer/footer.component';
import { SobremiComponent } from './pages/sobremi/sobremi.component';
import { DetalleComponent } from './pages/detalle/detalle.component';
import { DetalleWebComponent } from './pages/detalle-web/detalle-web.component';
import { DetalleVideoComponent } from './pages/detalle-video/detalle-video.component';
import { DetalleMoreComponent } from './pages/detalle-more/detalle-more.component';

// Gráficos
import { ChartsModule } from 'ng2-charts';
import { DgComponent } from './shared/graficas/dg/dg.component';
import { DwComponent } from './shared/graficas/dw/dw.component';
import { VidComponent } from './shared/graficas/vid/vid.component';
import { MoreComponent } from './shared/graficas/more/more.component';

// Servicios
import {DgService} from './service/dg.service';
import {WebService} from './service/web.service';
import { VideoService } from './service/video.service';
import {MoreService} from './service/more.service';
import { YoutubePipe } from './pipes/youtube.pipe';



@NgModule({
  declarations: [
    AppComponent,
    GraphicDesignComponent,
    VideoComponent,
    WebDesignComponent,
    AdemasComponent,
    MenuPrincipalComponent,
    PagesComponent,
    PrincipalComponent,
    FooterComponent,
    SobremiComponent,
    DgComponent,
    DwComponent,
    DetalleComponent,
    VidComponent,
    MoreComponent,
    DetalleWebComponent,
    DetalleVideoComponent,
    DetalleMoreComponent,
    YoutubePipe,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    APP_ROUTES,
    ChartsModule,
    HttpClientModule
  ],
  providers: [
    DgService,
    WebService,
    VideoService,
    MoreService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
